"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ContentFlow = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _FormBuilder = _interopRequireDefault(require("@civicplus/preamble/lib/FormBuilder/FormBuilder"));

var _PermissionSetSelector = require("../Shared/PermissionSetSelector");

var _ContentMapper = require("./ContentMapper");

var _Config = require("../Utility/Config");

var _CategoriesSelector = require("../Shared/CategoriesSelector");

var _TagsSelector = require("../Shared/TagsSelector");

var _Permissions = require("../Shared/Permissions");

var _StatusDropdown = require("../Shared/StatusDropdown");

var _VersionToggle = require("../Shared/VersionToggle");

var _ContentSaver = require("./ContentSaver");

var _Scheduler = require("../Shared/Schedule/Scheduler");

var _Alert = require("../Utility/Alert");

var _State = require("../Utility/State");

var _Loader = _interopRequireDefault(require("@civicplus/preamble/lib/Loader"));

var _contentFieldMapper = require("./contentFieldMapper");

var _Dialog = _interopRequireDefault(require("@civicplus/preamble/lib/Dialog"));

var _PromptUserForAssets = require("../Utility/PromptUserForAssets");

var _ContentTypeSelector = require("../Shared/ContentTypeSelector");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var emptyContent = function emptyContent() {
  return {
    permissionSet: undefined,
    categories: [],
    _links: {},
    lastModifiedBy: "",
    createdBy: "",
    data: {}
  };
};

var ContentFlow = function ContentFlow(props) {
  var _props$formBuilderPro, _getContent$categorie, _getContent$tags;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      fields = _useState2[0],
      setFields = _useState2[1];

  var formRef = (0, _react.useRef)();
  var initialized = fields.length > 0;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hasRunSetup = _useState4[0],
      setHasRunSetup = _useState4[1];

  var _useState5 = (0, _react.useState)(emptyContent()),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      currentContent = _useState6[0],
      setCurrentContent = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      oldContent = _useState8[0],
      setOldContent = _useState8[1];

  var contentApi = (0, _react.useRef)();

  var _useState9 = (0, _react.useState)(undefined),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      statusToChangeTo = _useState10[0],
      setStatusToChangeTo = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      modifying = _useState12[0],
      setModifying = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      viewingPast = _useState14[0],
      setViewingPast = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      dirty = _useState16[0],
      setDirty = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      isNoAccess = _useState18[0],
      setIsNoAccess = _useState18[1];

  var _useState19 = (0, _react.useState)(_State.State.None),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      savingState = _useState20[0],
      setSavingState = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
      openScheduler = _useState22[0],
      setOpenScheduler = _useState22[1];

  var _useState23 = (0, _react.useState)(null),
      _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
      schedulerProps = _useState24[0],
      setSchedulerProps = _useState24[1];

  var _useState25 = (0, _react.useState)(null),
      _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
      contentType = _useState26[0],
      setContentType = _useState26[1];

  var _useState27 = (0, _react.useState)(false),
      _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
      disableContentTypeSelector = _useState28[0],
      setDisableContentTypeSelector = _useState28[1];

  var _useState29 = (0, _react.useState)(null),
      _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
      permissions = _useState30[0],
      setPermissions = _useState30[1];

  var _useState31 = (0, _react.useState)(false),
      _useState32 = (0, _slicedToArray2["default"])(_useState31, 2),
      disableForm = _useState32[0],
      setDisableForm = _useState32[1];

  var getContent = (0, _react.useCallback)(function () {
    var _ref;

    return (_ref = oldContent !== null && oldContent !== void 0 ? oldContent : currentContent) !== null && _ref !== void 0 ? _ref : emptyContent();
  }, [currentContent, oldContent]);
  var mapFields = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var fields, provider, permissionSet;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (contentType) {
              _context.next = 2;
              break;
            }

            throw new Error("No current contentType");

          case 2:
            setSavingState(_State.State.Loading);
            fields = (0, _ContentMapper.mapToFormBuilderFields)(contentType, getContent());
            provider = new _Permissions.PermissionsProvider();
            _context.next = 7;
            return provider.load(props.config, currentContent, contentType);

          case 7:
            permissionSet = _context.sent;
            setPermissions(permissionSet);
            setFields(fields);
            setSavingState(_State.State.Finished);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [getContent, contentType, currentContent, props.config]);
  var fetchAndSetContentType = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(schemaName) {
      var config, contentTypeApi, contentTypeResult;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              config = (0, _Config.includeFlow)(props.config);
              contentTypeApi = new _sdk.ContentTypesApi(config);
              _context2.next = 4;
              return contentTypeApi.getContentType(props.config.appName, schemaName);

            case 4:
              contentTypeResult = _context2.sent;
              setContentType(contentTypeResult);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [props.config]);
  (0, _react.useEffect)(function () {
    // If we change the contentType dropdown, we need to map the fields again.
    if (contentType && currentContent.permissionSet) {
      mapFields();
    }
  }, [contentType, currentContent.permissionSet, mapFields]);
  (0, _react.useEffect)(function () {
    if (viewingPast || isNoAccess || savingState === _State.State.Loading) {
      setDisableForm(true);
    } else if (disableForm) {
      setDisableForm(false);
    }
  }, [disableForm, isNoAccess, savingState, viewingPast]);
  (0, _react.useEffect)(function () {
    function setup() {
      return _setup.apply(this, arguments);
    }

    function _setup() {
      _setup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var config;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                config = (0, _Config.includeFlow)(props.config);
                contentApi.current = new _sdk.ContentsApi(config);
                _context5.next = 4;
                return (0, _Alert.alertOnError)("Failed to load schema.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (props.schema) {
                            fetchAndSetContentType(props.schema);
                            setDisableContentTypeSelector(true);
                          } else if (disableContentTypeSelector) {
                            setDisableContentTypeSelector(false);
                          }

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));

              case 4:
                if (!props.contentId) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 7;
                return (0, _Alert.alertOnError)("Failed to load content.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                  var _yield$contentApi$cur;

                  var newContent;
                  return _regenerator["default"].wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (contentApi.current) {
                            _context4.next = 2;
                            break;
                          }

                          throw new Error("Content API current not defined");

                        case 2:
                          if (props.contentId) {
                            _context4.next = 4;
                            break;
                          }

                          throw new Error("Content ID undefined");

                        case 4:
                          _context4.next = 6;
                          return contentApi.current.getContent(props.config.appName, props.schema, props.contentId);

                        case 6:
                          _context4.t1 = _yield$contentApi$cur = _context4.sent;
                          _context4.t0 = _context4.t1 !== null;

                          if (!_context4.t0) {
                            _context4.next = 10;
                            break;
                          }

                          _context4.t0 = _yield$contentApi$cur !== void 0;

                        case 10:
                          if (!_context4.t0) {
                            _context4.next = 14;
                            break;
                          }

                          _context4.t2 = _yield$contentApi$cur;
                          _context4.next = 15;
                          break;

                        case 14:
                          _context4.t2 = emptyContent();

                        case 15:
                          newContent = _context4.t2;
                          setCurrentContent(newContent);
                          setModifying(true);

                        case 18:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })));

              case 7:
                if (contentType && currentContent.permissionSet && currentContent.id != null) {
                  setModifying(true);
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _setup.apply(this, arguments);
    }

    if (!hasRunSetup) {
      setHasRunSetup(true);
      setup();
    }
  }, [props.config, props.schema, props.contentId, mapFields, contentType, fetchAndSetContentType, disableContentTypeSelector, currentContent, hasRunSetup]);
  var onSave = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(data, status, content) {
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return (0, _Alert.runWithAlert)("Successfully saved content.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
                var _props$onSave;

                var saver, result;
                return _regenerator["default"].wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        if (contentType) {
                          _context6.next = 2;
                          break;
                        }

                        throw new Error("No current contentType");

                      case 2:
                        saver = new _ContentSaver.ContentSaver(props.config, content, contentType);
                        _context6.next = 5;
                        return saver.saveAsync(status, data);

                      case 5:
                        result = _context6.sent;
                        setCurrentContent(result);
                        setStatusToChangeTo(undefined);
                        (_props$onSave = props.onSave) === null || _props$onSave === void 0 ? void 0 : _props$onSave.call(props, result);

                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              })));

            case 2:
              setSavingState(_State.State.Finished);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x2, _x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }(), [contentType, props.config, props.onSave]);
  var onCreateDraft = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return (0, _Alert.runWithAlert)("Successfully created new version.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
              var updatedContent;
              return _regenerator["default"].wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      if (contentApi.current) {
                        _context8.next = 2;
                        break;
                      }

                      throw new Error("No current contentApi");

                    case 2:
                      if (contentType) {
                        _context8.next = 4;
                        break;
                      }

                      throw new Error("No current contentType");

                    case 4:
                      if (currentContent.id) {
                        _context8.next = 6;
                        break;
                      }

                      throw new Error("Current content is missing id");

                    case 6:
                      _context8.next = 8;
                      return contentApi.current.createDraft(props.config.appName, contentType.name, currentContent.id);

                    case 8:
                      updatedContent = _context8.sent;
                      setCurrentContent(updatedContent);
                      props.onDraftCreated(updatedContent);

                    case 11:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8);
            })));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })), [contentType, currentContent.id, props]);
  var onVersionToggled = (0, _react.useCallback)(function (version) {
    if (!oldContent) {
      setOldContent(version);
      setViewingPast(true);
    } else {
      setOldContent(undefined);
      setViewingPast(false);
    }

    setFields([]);
    setSavingState(_State.State.Processing); // Wait till next tick before mapping to force FormBuilder to reload.

    setTimeout(function () {
      mapFields();
    }, 150);
  }, [mapFields, oldContent]);
  var closeScheduler = (0, _react.useCallback)(function () {
    setOpenScheduler(false);
    setSchedulerProps(null);
  }, []);

  var hasRecurrenceField = function hasRecurrenceField(data) {
    var hasRecurrence = false;
    Object.keys(data).forEach(function (k) {
      var dataProperty = data[k];
      var recurrenceObj = dataProperty.recurrence;

      if (recurrenceObj && recurrenceObj.type !== "None" && (recurrenceObj.interval || recurrenceObj.ocurrences || recurrenceObj.type)) {
        hasRecurrence = true;
      }
    });
    return hasRecurrence;
  };

  var onCancelScheduling = (0, _react.useCallback)(function () {
    closeScheduler();
    setSavingState(_State.State.None);
  }, [closeScheduler]);
  var submit = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(newStatus) {
      var data, config, shouldShowScheduler, defaultMessage, scheduleprops, _props$onFailure;

      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              setStatusToChangeTo(newStatus);

              if (formRef.current) {
                _context11.next = 4;
                break;
              }

              throw new Error("Form reference not set");

            case 4:
              setSavingState(_State.State.Processing);
              _context11.next = 7;
              return formRef.current.submit();

            case 7:
              data = _context11.sent;
              config = props.config;

              shouldShowScheduler = function shouldShowScheduler() {
                if (!currentContent.id && hasRecurrenceField(data)) {
                  return false;
                }

                return newStatus != null || currentContent.status === "Published" && !currentContent.newStatus;
              }; // If we are not changing status, just save right away.
              // otherwise we should show the schedule dialog.


              if (shouldShowScheduler()) {
                _context11.next = 15;
                break;
              }

              _context11.next = 13;
              return onSave(data, newStatus, currentContent);

            case 13:
              _context11.next = 24;
              break;

            case 15:
              if (contentType) {
                _context11.next = 17;
                break;
              }

              throw new Error("No current contentType");

            case 17:
              _context11.next = 19;
              return (0, _ContentMapper.mapFormBuilderResultToSchema)(config, data, contentType);

            case 19:
              currentContent.data = _context11.sent;
              defaultMessage = modifying ? "A modification to a ".concat((contentType === null || contentType === void 0 ? void 0 : contentType.properties.label) || (contentType === null || contentType === void 0 ? void 0 : contentType.name), " has been made!") : "A new ".concat((contentType === null || contentType === void 0 ? void 0 : contentType.properties.label) || (contentType === null || contentType === void 0 ? void 0 : contentType.name), " has been created!");
              scheduleprops = {
                onCancel: onCancelScheduling,
                item: currentContent,
                schema: contentType,
                status: newStatus || currentContent.status,
                onConfirm: function () {
                  var _onConfirm = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(item) {
                    return _regenerator["default"].wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            setCurrentContent(item);
                            _context10.next = 3;
                            return onSave(data, newStatus, item);

                          case 3:
                            closeScheduler();

                          case 4:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  function onConfirm(_x6) {
                    return _onConfirm.apply(this, arguments);
                  }

                  return onConfirm;
                }(),
                defaultEmailSubject: defaultMessage,
                defaultTextMessage: defaultMessage
              };
              setOpenScheduler(true);
              setSchedulerProps(scheduleprops);

            case 24:
              _context11.next = 32;
              break;

            case 26:
              _context11.prev = 26;
              _context11.t0 = _context11["catch"](0);
              (_props$onFailure = props.onFailure) === null || _props$onFailure === void 0 ? void 0 : _props$onFailure.call(props, _context11.t0, currentContent);
              closeScheduler();
              setSavingState(_State.State.None);
              throw new Error("Failed to save, something went wrong.");

            case 32:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 26]]);
    }));

    return function (_x5) {
      return _ref10.apply(this, arguments);
    };
  }(), [closeScheduler, contentType, currentContent, modifying, onCancelScheduling, onSave, props.config, props.onFailure]);
  var onEditSchedule = (0, _react.useCallback)(function (job) {
    var scheduleprops = {
      schema: contentType,
      status: job.status,
      item: currentContent,
      onCancel: onCancelScheduling,
      onConfirm: function () {
        var _onConfirm2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(item) {
          return _regenerator["default"].wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  closeScheduler();
                  _context13.next = 3;
                  return (0, _Alert.runWithAlert)("Successfully updated schedule.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
                    var _props$onScheduleChan;

                    var saver, result;
                    return _regenerator["default"].wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            if (contentType) {
                              _context12.next = 2;
                              break;
                            }

                            throw new Error("No current contentType");

                          case 2:
                            saver = new _ContentSaver.ContentSaver(props.config, item, contentType);
                            _context12.next = 5;
                            return saver.saveAsync(job.status);

                          case 5:
                            result = _context12.sent;
                            setCurrentContent(result);
                            setStatusToChangeTo(undefined);
                            (_props$onScheduleChan = props.onScheduleChange) === null || _props$onScheduleChan === void 0 ? void 0 : _props$onScheduleChan.call(props, result);

                          case 9:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  })));

                case 3:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }));

        function onConfirm(_x7) {
          return _onConfirm2.apply(this, arguments);
        }

        return onConfirm;
      }()
    };
    setSchedulerProps(scheduleprops);
    setOpenScheduler(true);
  }, [closeScheduler, contentType, currentContent, onCancelScheduling, props.config, props.onScheduleChange]);
  var onClearSchedule = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(job) {
      return _regenerator["default"].wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return (0, _Alert.runWithAlert)("Successfully cleared schedule.", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
                var _props$onScheduleChan2;

                return _regenerator["default"].wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        if (contentApi.current) {
                          _context14.next = 2;
                          break;
                        }

                        throw new Error("No current contentApi");

                      case 2:
                        if (contentType) {
                          _context14.next = 4;
                          break;
                        }

                        throw new Error("No current contentType");

                      case 4:
                        if (currentContent.id) {
                          _context14.next = 6;
                          break;
                        }

                        throw new Error("Current content is missing id");

                      case 6:
                        _context14.next = 8;
                        return contentApi.current.clearSchedule(props.config.appName, contentType.name, currentContent.id);

                      case 8:
                        (_props$onScheduleChan2 = props.onScheduleChange) === null || _props$onScheduleChan2 === void 0 ? void 0 : _props$onScheduleChan2.call(props);

                      case 9:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14);
              })));

            case 2:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x8) {
      return _ref12.apply(this, arguments);
    };
  }(), [contentType, currentContent.id, props.config.appName, props.onScheduleChange]);

  var localFormBuilderProps = _objectSpread({}, (_props$formBuilderPro = props.formBuilderProps) !== null && _props$formBuilderPro !== void 0 ? _props$formBuilderPro : {});

  localFormBuilderProps.fieldConfiguration = _objectSpread(_objectSpread({}, localFormBuilderProps.fieldConfiguration), {}, {
    forceHtmlView: savingState === _State.State.Processing,
    promptUserForAssetsAsync: (0, _PromptUserForAssets.getPromptUserForAssetsForEditor)(props.config),
    allowRecurring: !currentContent.id
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id,
    className: "prmbl-contentFlow"
  }, initialized && permissions && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StatusDropdown.StatusDropdown, {
    item: currentContent,
    permissions: permissions,
    saving: savingState === _State.State.Processing,
    disabled: viewingPast || isNoAccess,
    saveDisabled: !dirty || disableForm,
    onNoAccess: function onNoAccess() {
      return setIsNoAccess(true);
    },
    onHasAccess: function onHasAccess() {
      return setIsNoAccess(false);
    },
    onClearSchedule: onClearSchedule,
    onEditSchedule: onEditSchedule,
    onCreateDraft: onCreateDraft,
    onSave: function onSave() {
      submit(undefined);
    },
    isNew: !modifying,
    onStatusChange: function onStatusChange(status) {
      submit(status.status);
    }
  }), schedulerProps && /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: openScheduler,
    title: statusToChangeTo || "",
    onClose: onCancelScheduling
  }, /*#__PURE__*/_react["default"].createElement(_Scheduler.Scheduler, schedulerProps))), /*#__PURE__*/_react["default"].createElement(_ContentTypeSelector.ContentTypeSelector, {
    config: props.config,
    disabled: disableContentTypeSelector || savingState === _State.State.Loading,
    value: contentType === null || contentType === void 0 ? void 0 : contentType.name,
    onChange: /*#__PURE__*/function () {
      var _ref14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(contentType) {
        var _props$onContentTypeC;

        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (contentType) {
                  (_props$onContentTypeC = props.onContentTypeChange) === null || _props$onContentTypeC === void 0 ? void 0 : _props$onContentTypeC.call(props, contentType);
                }

                !dirty && setDirty(true);
                setFields([]);
                setCurrentContent(_objectSpread(_objectSpread({}, emptyContent()), {}, {
                  permissionSet: currentContent.permissionSet,
                  categories: currentContent.categories,
                  tags: currentContent.tags
                }));
                setOldContent(undefined);

                if (!(contentType !== null && contentType !== void 0 && contentType.name)) {
                  _context16.next = 8;
                  break;
                }

                _context16.next = 8;
                return fetchAndSetContentType(contentType === null || contentType === void 0 ? void 0 : contentType.name);

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      return function (_x9) {
        return _ref14.apply(this, arguments);
      };
    }()
  }), contentType && /*#__PURE__*/_react["default"].createElement(_PermissionSetSelector.PermissionSetSelector, {
    config: props.config,
    disabled: disableForm,
    value: getContent().permissionSet,
    onChange: function onChange(set) {
      !dirty && setDirty(true);
      setCurrentContent(_objectSpread(_objectSpread({}, currentContent), {}, {
        permissionSet: set
      }));
    },
    contentTypeName: contentType === null || contentType === void 0 ? void 0 : contentType.name,
    isCreating: !modifying
  }), contentType && /*#__PURE__*/_react["default"].createElement(_VersionToggle.VersionToggle, {
    item: currentContent,
    config: props.config,
    schema: contentType,
    onVersionLoaded: function onVersionLoaded(data) {
      return onVersionToggled(data);
    }
  }), (savingState === _State.State.Processing || savingState === _State.State.Loading) && /*#__PURE__*/_react["default"].createElement(_Loader["default"], null), initialized && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormBuilder["default"], (0, _extends2["default"])({
    hideLoadingIndicator: true,
    onChange: function onChange(field, data) {
      !dirty && setDirty(true);
    },
    fields: fields,
    variant: disableForm ? "readOnly" : "editable",
    disableNotifications: true,
    onRef: function onRef(ref) {
      return formRef.current = ref;
    },
    id: "hcms-content-flow"
  }, localFormBuilderProps, {
    fieldMapper: function fieldMapper(field) {
      return (0, _contentFieldMapper.contentFieldMapper)({
        field: field,
        config: props.config
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_CategoriesSelector.CategoriesSelector, {
    value: (_getContent$categorie = getContent().categories) !== null && _getContent$categorie !== void 0 ? _getContent$categorie : [],
    label: "Categories",
    disabled: disableForm,
    config: props.config,
    onChange: function onChange(categories) {
      !dirty && setDirty(true);
      setCurrentContent(_objectSpread(_objectSpread({}, currentContent), {}, {
        categories: categories
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_TagsSelector.TagsSelector, {
    value: (_getContent$tags = getContent().tags) !== null && _getContent$tags !== void 0 ? _getContent$tags : [],
    label: "Tags",
    disabled: disableForm,
    onChange: function onChange(tags) {
      !dirty && setDirty(true);
      setCurrentContent(_objectSpread(_objectSpread({}, currentContent), {}, {
        tags: tags
      }));
    }
  })));
};

exports.ContentFlow = ContentFlow;
var _default = ContentFlow;
exports["default"] = _default;